export const getEffectiveDate = (strDates, currentDateStr) =>  {
    const datesSorted = strDates.filter(date => date !== null)
                                .sort((d1, d2) => d1.parseJSONDate() - d2.parseJSONDate())

    const effectiveDateIndex = _.findLastIndex(datesSorted, d => d <= currentDateStr)
    return effectiveDateIndex > -1 ? datesSorted[effectiveDateIndex] : null
}


// WEBPACK FOOTER //
// ./web/js/panels/user/accountSettings/utils.js